export default __webpack_public_path__ + "static/media/addG.d14dade9.svg";